module.exports = __webpack_public_path__ + "img/product_dp.31e42d67.png";